import { render, staticRenderFns } from "./sideBarMenu.vue?vue&type=template&id=818ae78c&scoped=true&lang=pug&"
import script from "./sideBarMenu.vue?vue&type=script&lang=ts&"
export * from "./sideBarMenu.vue?vue&type=script&lang=ts&"
import style0 from "./sideBarMenu.vue?vue&type=style&index=0&id=818ae78c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818ae78c",
  null
  
)

export default component.exports